import React from 'react';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const CheckIcon = React.memo(function CheckIcon(props: TCheckIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Check" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 18.0555C14.5899 18.0555 17.5 15.1454 17.5 11.5555C17.5 7.96569 14.5899 5.05554 11 5.05554C7.41015 5.05554 4.5 7.96569 4.5 11.5555C4.5 15.1454 7.41015 18.0555 11 18.0555ZM11 19.5555C15.4183 19.5555 19 15.9738 19 11.5555C19 7.13726 15.4183 3.55554 11 3.55554C6.58172 3.55554 3 7.13726 3 11.5555C3 15.9738 6.58172 19.5555 11 19.5555Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.4692 8.35977C14.7983 8.61139 14.861 9.0821 14.6094 9.41113L10.6329 14.6111C10.5016 14.7829 10.3026 14.8896 10.0868 14.9039C9.87112 14.9182 9.65972 14.8387 9.50684 14.6859L7.36567 12.5447C7.07277 12.2518 7.07277 11.7769 7.36567 11.484C7.65856 11.1911 8.13343 11.1911 8.42633 11.484L9.96177 13.0195L13.4179 8.49995C13.6695 8.17092 14.1402 8.10816 14.4692 8.35977Z"
            />
        </IconBase>
    );
});

export default CheckIcon;

// #region Types

export type TCheckIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <CheckIcon /> : { ...IconBaseExample, render: CheckIcon };

// #endregion
